<template>
    <v-card-text class="pt-0">
        <v-layout row wrap>

            <confirmation-header-text :text="headerText?headerText:$vuetify.lang.t('$vuetify.visa_details')" class="ml-2"
                                      icon="mdi-card-bulleted"/>

            <v-flex md3 xs12>
                <list-item-detail
                        :sub_title="visa.visa_type +' ('+visa.plan+')'"
                        :title="$vuetify.lang.t('$vuetify.visa_type')"/>
            </v-flex>

            <v-flex md3 xs12>
                <list-item-detail
                        :sub_title="visa.visa_number"
                        :title="$vuetify.lang.t('$vuetify.visa_number')"/>
            </v-flex>

            <v-flex md3 xs12>
                <list-item-detail
                        :sub_title="visa.submission_no"
                        title="Submission Id"/>
            </v-flex>

            <v-flex md3 xs12>
                <list-item-detail
                        :sub_title="visa.start_date + ' to ' +visa.expiry_date"
                        title="Visa Duration"/>
            </v-flex>

            <v-flex xs12>
                <v-divider class="my-1"/>
            </v-flex>

            <confirmation-header-text :text="$vuetify.lang.t('$vuetify.personal_details')"
                                      class="ml-2"
                                      icon="mdi-account-box"/>

            <v-flex md3 xs12>
                <list-item-detail
                        :sub_title="visa.full_name"
                        :title="$vuetify.lang.t('$vuetify.full_name')"/>
            </v-flex>
            <v-flex md3 xs12>
                <list-item-detail
                        :sub_title="visa.country_name"
                        :title="$vuetify.lang.t('$vuetify.country')"/>
            </v-flex>
            <v-flex md3 xs12>
                <list-item-detail
                        :sub_title="visa.dob"
                        :title="$vuetify.lang.t('$vuetify.dob')"/>
            </v-flex>
            <v-flex xs12>
                <v-divider class="my-1"/>
            </v-flex>

            <confirmation-header-text class="ml-2" icon="mdi-passport"
                                      :text="visa.document_type.toLowerCase().includes('passport')?'Passport Details':'Identity Details'"/>

            <v-flex md3 xs12>
                <list-item-detail
                        :sub_title="visa.document_type"
                        :title="visa.document_type.toLowerCase().includes('passport')?'Passport Type':'Document Type'"/>
            </v-flex>

            <v-flex md3 xs12>
                <list-item-detail
                        :sub_title="visa.passport_number"
                        :title="visa.document_type.toLowerCase().includes('passport')?'Passport No.':visa.document_type"/>
            </v-flex>

            <v-flex md3 xs12>
                <list-item-detail
                        :sub_title="visa.validity"
                        :title="visa.document_type.toLowerCase().includes('passport')?'Passport Expiry Date':'Document Expiry Date'"/>
            </v-flex>

        </v-layout>
    </v-card-text>
</template>

<script>
    import ListItemDetail from "../components/ListItemDetail";
    import ConfirmationHeaderText from "../components/ConfirmationHeaderText";

    export default {
        name: "VisaDetail",
        props: ['visa', 'headerText'],
        components: {
            ListItemDetail, ConfirmationHeaderText
        },
        computed: {
            visa_type() {
                return (this.visa.dependent_visa ? "Dependent " : " ") + this.visa.visa_type;
            }
        }
    }
</script>

